var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 37,
    viewBox: "0 0 226 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "63afdfc8ea6dbc74dfd7b2ad_Frame%2097221.svg",
    clipPath: "url(#clip0_2552_36239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5119 0.762703L22.5523 13.2579L35.6273 13.2557L25.0494 20.9804L29.0898 33.4755L18.5119 25.7544L7.934 33.4791L11.9744 20.9826L1.39648 13.2615L14.4715 13.2593L18.5119 0.762703Z",
    fill: "#FFDE64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.7268 0.75489L69.7672 13.2501L82.8422 13.2478L72.2643 20.9726L76.3047 33.4677L65.7268 25.7466L55.1488 33.4713L59.1892 20.9748L48.6113 13.2537L61.6864 13.2515L65.7268 0.75489Z",
    fill: "#FFDE64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M112.936 0.747078L116.976 13.2423L130.051 13.24L119.473 20.9648L123.514 33.4599L112.936 25.7388L102.358 33.4635L106.398 20.967L95.8203 13.2459L108.895 13.2436L112.936 0.747078Z",
    fill: "#FFDE64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M160.151 0.739265L164.191 13.2345L177.267 13.2322L166.689 20.9569L170.729 33.4521L160.151 25.731L149.573 33.4557L153.613 20.9592L143.035 13.2381L156.111 13.2358L160.151 0.739265Z",
    fill: "#FFDE64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M207.366 0.729499L211.406 13.2247L224.481 13.2225L213.903 20.9472L217.944 33.4423L207.366 25.7212L196.788 33.4459L200.828 20.9494L190.25 13.2283L203.326 13.2261L207.366 0.729499Z",
    fill: "#FFDE64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2552_36239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.053,
    height: 36.1684,
    fill: "white",
    transform: "matrix(0.995134 -0.000169921 0 1 0.511719 0.765625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.b11c57447d547c422bb30996d07b8296.svg";
export { ForwardRef as ReactComponent };